export default __webpack_public_path__ + "static/media/oppo.e912a397.jpg";